import { Subject } from 'rxjs'
const subject = new Subject()

export const episodeService = {
	setEpisode: e => subject.next({ episode: e }),
	clearEpisode: () => subject.next(),
	getEpisode: () => subject.asObservable()
}
